<template>
  <div>
    <v-dialog v-model="dialog" width="300">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="d-flex flx-row align-center mt-2">
          <div v-if="currentRebate" class="mr-2 caption">
            After {{ currentRebate | currency }} rebate
          </div>

          <v-btn x-small depressed rounded @click="populateRebate">
            {{ currentRebate ? "edit" : "Add Rebate" }}
          </v-btn>
        </div>
      </template>

      <v-card>
        <v-card-title>
          Year Supply Rebate
        </v-card-title>

        <v-card-text class="text-center justify-center pa-3">
          <v-text-field
            v-model="rebate"
            label="rebate"
            value=""
            prefix="$"
            class="medNum mx-2"
            hide-details="auto"
            dense
            ref="daInput"
            v-on:keyup.enter="submitRebate"
          ></v-text-field>
          <!-- <v-btn @click="rebate=0" color="warning">Clear Rebate</v-btn> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="submitRebate">
            Add Rebate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "AddRebateDialog",
  props: {
    currentRebate: {
      type: Number,
      default: null
    }
  },
  data: function() {
    return {
      dialog: false,
      rebate: null
    };
  },
  methods: {
    populateRebate() {
      this.rebate = this.currentRebate;
      // this.$refs.daInput.$el.focus();
    },
    submitRebate() {
      let rebate = parseFloat(this.rebate);
      rebate = rebate ? Math.abs(rebate) : null;
      this.$emit("rebate", rebate);
      this.dialog = false;
    }
  },
  computed: {},
  mounted() {
    //setTimeout(() => this.$refs.daInput.focus(), 100);
  }
};
</script>

<style scoped></style>
